// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__EYtFl","arrowicon":"Button_arrowicon__SoU37","btncontent":"Button_btncontent__ECVWz","btntext":"Button_btntext__q6yMi"};